
import { useState } from 'react';

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const galleryImages = [
    {
      src: 'https://readdy.ai/api/search-image?query=Beautiful%20nail%20art%20designs%20featuring%20colorful%20geometric%20patterns%2C%20floral%20motifs%2C%20and%20gradient%20effects%20on%20perfectly%20manicured%20nails%20displayed%20on%20a%20clean%20white%20background%20with%20professional%20lighting&width=400&height=400&seq=nail-art-1&orientation=squarish',
      alt: 'カラフルなネイルアート作品',
      title: 'ジオメトリックデザイン'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Elegant%20French%20manicure%20with%20modern%20twist%2C%20featuring%20subtle%20glitter%20accents%20and%20clean%20lines%20on%20natural%20nails%2C%20photographed%20in%20soft%20natural%20lighting%20with%20minimalist%20background&width=400&height=400&seq=nail-art-2&orientation=squarish',
      alt: 'エレガントなフレンチネイル',
      title: 'モダンフレンチ'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Trendy%20nail%20art%20with%20holographic%20effects%2C%20chrome%20finish%2C%20and%20iridescent%20colors%20creating%20a%20futuristic%20look%20on%20well-shaped%20nails%20against%20a%20clean%20studio%20background&width=400&height=400&seq=nail-art-3&orientation=squarish',
      alt: 'ホログラフィックネイル',
      title: 'ホログラフィック'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Delicate%20floral%20nail%20art%20with%20hand-painted%20roses%2C%20leaves%2C%20and%20botanical%20elements%20in%20soft%20pastel%20colors%20on%20nude%20base%2C%20showcasing%20artistic%20skill%20and%20attention%20to%20detail&width=400&height=400&seq=nail-art-4&orientation=squarish',
      alt: 'フローラルネイルアート',
      title: 'フローラルアート'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Minimalist%20nail%20design%20with%20clean%20lines%2C%20negative%20space%2C%20and%20subtle%20metallic%20accents%20perfect%20for%20both%20men%20and%20women%2C%20photographed%20in%20professional%20studio%20lighting&width=400&height=400&seq=nail-art-5&orientation=squarish',
      alt: 'ミニマリストデザイン',
      title: 'ミニマリスト'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Seasonal%20nail%20art%20featuring%20autumn%20colors%2C%20leaf%20patterns%2C%20and%20warm%20tones%20with%20matte%20and%20glossy%20finish%20combinations%20on%20perfectly%20shaped%20nails%20in%20natural%20lighting&width=400&height=400&seq=nail-art-6&orientation=squarish',
      alt: 'シーズナルネイル',
      title: 'シーズナル'
    }
  ];

  return (
    <section id="gallery" className="py-20 bg-gradient-to-br from-pink-50 to-teal-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h3 className="text-4xl md:text-5xl font-bold mb-6 text-gray-800">
            <strong>作品ギャラリー</strong>
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            これまでに手がけた美しいネイルアート作品の数々をご覧ください
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
          {galleryImages.map((image, index) => (
            <div 
              key={index}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
              onClick={() => setSelectedImage(image.src)}
            >
              <img 
                src={image.src}
                alt={image.alt}
                title={image.title}
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 text-white">
                  <h4 className="font-semibold text-lg">{image.title}</h4>
                  <p className="text-sm opacity-90">クリックで拡大</p>
                </div>
              </div>
              <div className="absolute top-4 right-4 w-8 h-8 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-zoom-in-line text-white"></i>
              </div>
            </div>
          ))}
        </div>

        {/* Modal for enlarged image */}
        {selectedImage && (
          <div 
            className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4"
            onClick={() => setSelectedImage(null)}
          >
            <div className="relative max-w-4xl max-h-full">
              <img 
                src={selectedImage}
                alt="拡大表示"
                className="max-w-full max-h-full object-contain rounded-lg"
              />
              <button 
                onClick={() => setSelectedImage(null)}
                className="absolute top-4 right-4 w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
          </div>
        )}

        
      </div>
    </section>
  );
}
